// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert-display {\n    white-space: pre-line;\n}", "",{"version":3,"sources":["webpack://src/reggora_shared_ui/components/DataEntry/CoverageEditor/style.scss"],"names":[],"mappings":"AAAA;IACI,qBAAA;AACJ","sourcesContent":[".alert-display {\n    white-space: pre-line;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
